import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import FormField from '../../../../dynamicFormBuilder/FormField'
import data from "../../../../assets/apiRoutes.json";
import axios from "axios";
import ValidationSummary from 'devextreme-react/validation-summary';
import { TabPanel, Item as TabItem } from 'devextreme-react/tab-panel';
import { LoadPanel } from 'devextreme-react/load-panel';
import notify from 'devextreme/ui/notify';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { alert, confirm } from 'devextreme/ui/dialog';
import Toolbar, { Item } from "devextreme-react/toolbar";
import { SelectBox } from 'devextreme-react/select-box';
const CodesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCODE_1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 1",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 2",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 3",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 4",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 5",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_6",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 6",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_7",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 7",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_8",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 8",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_9",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 9",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_10",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 10",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDDATE_1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 1",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 2",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 3",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 4",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 5",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_6",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 6",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_7",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 7",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_8",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 8",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_9",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 9",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_10",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 10",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDQUANTITY_1",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 1",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 2",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 3",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_4",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 4",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_5",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 5",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_6",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 6",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_7",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 7",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_8",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 8",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_9",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 9",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_10",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 10",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
]
const Codes_11_20_Layout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCODE_11",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 11",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_12",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 12",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_13",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 13",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_14",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 14",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_15",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 15",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_16",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 16",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_17",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 17",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_18",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 18",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_19",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 19",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCODE_20",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "CODE 20",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDDATE_11",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 11",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_12",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 12",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_13",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 13",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_14",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 14",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_15",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 15",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_16",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 16",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_17",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 17",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_18",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 18",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_19",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 19",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDDATE_20",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Date 20",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDQUANTITY_11",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 11",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_12",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 12",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_13",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 13",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_14",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 14",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_15",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 15",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_16",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 16",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_17",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 17",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_18",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 18",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_19",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 19",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDQUANTITY_20",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Quantity 20",
                "type": "number", "format":"#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ]
    }
]
const RefrencesLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [            
            {
            "name": "USERDEFINEDREFERENCE_1",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 1",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_2",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 2",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_3",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 3",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_4",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 4",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_5",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 5",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_6",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 6",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_7",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 7",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_8",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 8",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_9",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 1",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_10",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 1",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },

    ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [            
            {
            "name": "USERDEFINEDCOMMENT",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Comment",
            "type": "textarea",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        }
    ]
    }
]
const Refrences_11_20_Layout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [            
            {
            "name": "USERDEFINEDREFERENCE_11",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 11",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_12",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 12",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_13",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 13",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_14",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 14",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_15",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 15",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_16",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 16",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_17",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 17",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_18",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 18",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_19",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 19",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },
        {
            "name": "USERDEFINEDREFERENCE_20",
            "tableName": "WMTRANSACTIONHEADER",
            "label": "Reference 20",
            "type": "text",
            "required": false,
            "visible": true,
            "isLabelChanged": false,
        },

    ]
    }
]
const CommentsLayout = [

    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "USERDEFINEDCOMMENT_2",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Comment 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "USERDEFINEDCOMMENT_3",
                "tableName": "WMTRANSACTIONHEADER",
                "label": "Comment 3",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
  
        ]
    }
]
function UserDefinedTab(props) {
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, [setLoadPanelVisible]);
    const position = { of: '#accordion-containe2' };
    var currentUser = props.oidc.user;
    const formRefs = useRef({});
    const handleCodesFormLoad = useCallback(() => {
        const code1DataSource = GetCodeByType("03");
        const code2DataSource = GetCodeByType("04");
        const code3DataSource = GetCodeByType("05");
        const code4DataSource = GetCodeByType("06");
        const code5DataSource = GetCodeByType("07");
        const code6DataSource = GetCodeByType("08");
        const code7DataSource = GetCodeByType("09");
        const code8DataSource = GetCodeByType("10");
        const code9DataSource = GetCodeByType("11");
        const code10DataSource = GetCodeByType("12");
        loadLookupFromDataSource('USERDEFINEDCODE_1', code1DataSource )
        loadLookupFromDataSource('USERDEFINEDCODE_2', code2DataSource )
        loadLookupFromDataSource('USERDEFINEDCODE_3', code3DataSource )
        loadLookupFromDataSource('USERDEFINEDCODE_4', code4DataSource )
        loadLookupFromDataSource('USERDEFINEDCODE_5', code5DataSource )
        loadLookupFromDataSource('USERDEFINEDCODE_6', code6DataSource )
        loadLookupFromDataSource('USERDEFINEDCODE_7', code7DataSource )
        loadLookupFromDataSource('USERDEFINEDCODE_8', code8DataSource )
        loadLookupFromDataSource('USERDEFINEDCODE_9', code9DataSource )
        loadLookupFromDataSource('USERDEFINEDCODE_10',code10DataSource)
    },[]);
    const handleCodes_11_20_FormLoad = useCallback(() => {
        const code11DataSource = GetCodeByType("D0");
        const code12DataSource = GetCodeByType("D1");
        const code13DataSource = GetCodeByType("D2");
        const code14DataSource = GetCodeByType("D3");
        const code15DataSource = GetCodeByType("D4");
        const code16DataSource = GetCodeByType("D5");
        const code17DataSource = GetCodeByType("D6");
        const code18DataSource = GetCodeByType("D7");
        const code19DataSource = GetCodeByType("D8");
        const code20DataSource = GetCodeByType("D9");
        loadLookupFromDataSource('USERDEFINEDCODE_11',code11DataSource)
        loadLookupFromDataSource('USERDEFINEDCODE_12',code12DataSource)
        loadLookupFromDataSource('USERDEFINEDCODE_13',code13DataSource)
        loadLookupFromDataSource('USERDEFINEDCODE_14',code14DataSource)
        loadLookupFromDataSource('USERDEFINEDCODE_15',code15DataSource)
        loadLookupFromDataSource('USERDEFINEDCODE_16',code16DataSource)
        loadLookupFromDataSource('USERDEFINEDCODE_17',code17DataSource)
        loadLookupFromDataSource('USERDEFINEDCODE_18',code18DataSource)
        loadLookupFromDataSource('USERDEFINEDCODE_19',code19DataSource)
        loadLookupFromDataSource('USERDEFINEDCODE_20',code20DataSource)
    });
    const handleRefrencesFormLoad = useCallback(() => {

    },[]);
    const handleCommentsFormLoad = useCallback(() => {

    },[]);
    const handleRefrences_11_20_FormLoad = useCallback(() => {

    },[]);
    const handleFieldChange = useCallback((name, value, e) => {
    },[]);
    const GetCodeByType = (type) => {
        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                key: 'name',
                loadParams: {
                    codeType: type,
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return items;
    };

    const loadLookupFromDataSource = (name, dataSource) => {
        if (formRefs.current[name]) {
            formRefs.current[name].instance().option('dataSource', dataSource);
            formRefs.current[name].instance().option('valueExpr', 'name');
            formRefs.current[name].instance().option('displayExpr', 'name');
        }
        else {
            console.log('not found control:');
        }
    };
    return (
        <div>
            <div className="row dataEntryMainPage">
                <div className="col-md-12 main-page">
                    <div id="accordion">
                        <LoadPanel
                            shadingColor="rgba(0,0,0,0.4)"
                            position={position}
                            onHiding={hideLoadPanel}
                            visible={loadPanelVisible}
                            showIndicator={true}
                            shading={true}
                            showPane={true}
                            hideOnOutsideClick={false}
                        />
 
                        <div className="AccordionItemBody">
                            <TabPanel className="TabpanelContainer">
                                <TabItem title="Codes">
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId='D9F97E52-EDB1-45AC-968E-CCA70C1B5DB8'
                                        layoutName='WMTransactionDataEntryUserDefinedTab'
                                        defaultFormSchema={CodesLayout}
                                        formFields={props.formFields}
                                        setformFields={props.setformFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handleCodesFormLoad}
                                    />
                                </TabItem>
                                <TabItem title="Refrences">
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId='1DFF01CD-DE3A-41A6-B4E0-F150F8225C40'
                                        layoutName='WMTransactionDataEntryUserDefinedTab'
                                        defaultFormSchema={RefrencesLayout}
                                        formFields={props.formFields}
                                        setformFields={props.setformFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handleRefrencesFormLoad}
                                    />
                                </TabItem>
                                <TabItem title="Comments">
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId='06E4A406-64F0-4EED-96A3-D241CADDF456'
                                        layoutName='WMTransactionDataEntryUserDefinedTab'
                                        defaultFormSchema={CommentsLayout}
                                        formFields={props.formFields}
                                        setformFields={props.setformFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handleCommentsFormLoad}
                                    />
                                </TabItem>
                                <TabItem title="Codes 11-20">
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId='32AC17B9-FEBC-4CF4-9B65-BD829406989C'
                                        layoutName='WMTransactionDataEntryUserDefinedTab'
                                        defaultFormSchema={Codes_11_20_Layout}
                                        formFields={props.formFields}
                                        setformFields={props.setformFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handleCodes_11_20_FormLoad}
                                    />
                                </TabItem>
                                <TabItem title="Refrences 11-20">
                                    <FormField
                                        currrentUser={currentUser}
                                        layoutId='D4D2A647-53CC-4B98-BE8C-7DA18A8C0CAA'
                                        layoutName='WMTransactionDataEntryUserDefinedTab'
                                        defaultFormSchema={Refrences_11_20_Layout}
                                        formFields={props.formFields}
                                        setformFields={props.setformFields}
                                        handleFieldValueChange={handleFieldChange}
                                        DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                        formRefs={formRefs}
                                        onFormLoad={handleRefrences_11_20_FormLoad}
                                    />
                                </TabItem>
                            </TabPanel>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UserDefinedTab);
